import React from 'react';
import Frame from './components/Frame';
import { IProductCard } from './interface';

function ProductCard(props: IProductCard) {
  return (
    <Frame.Base onClick={props.onClick} isActive={props.active}>
      {props.children}
    </Frame.Base>
  );
}

export default ProductCard;
